import type { RelationFieldProps } from './types';
import {
  SpaceNotationCategoryConfig,
  type SpaceNotationCategory,
} from '@pigello/pigello-matrix';
import { getRelationFieldNames } from '@/requests/instanceMapper';

export const SpaceNotationCategoryItem: RelationFieldProps<SpaceNotationCategory> =
  {
    nested: getRelationFieldNames(SpaceNotationCategoryConfig),
    renderItem: (item) => ({
      title: item.name,
      descriptionItems: <div>{item.description}</div>,
    }),
  };
